import { ErrorData, ICountryCodeData, IResponse } from '@/types/common';
import { types } from 'mobx-state-tree';
import { withAlertStore } from '../alert/withAlertStore';
import { ISelectedCountryCodeData, Theme } from './types';
import { AxiosError } from 'axios';

const { model, boolean, maybeNull, frozen } = types;

export const MainStore = model('MainStore', {
  globalLoading: boolean,
  selectedCountryCode: maybeNull(frozen<ICountryCodeData>()),
  theme: frozen<Theme>(),
})
  .extend(withAlertStore)
  .views((self) => ({}))
  .actions((self) => ({
    afterCreate() {
      const stored = localStorage.getItem('theme') as Theme | null;
      // TODO if we want to use user's browser prefers
      // const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      // const initial = stored || (prefersDark ? 'dark' : 'light');
      const initial = stored || 'light';
      self.theme = initial;
      document.documentElement.classList.toggle('dark', initial === 'dark');
    },
    errorHandling(data: AxiosError<IResponse<ErrorData>>) {
      if (import.meta.env.MODE === 'development')
        console.error('DEVELOPMENT ERROR: \n' + JSON.stringify(data, null, 2));
      const { response } = data;
      const msg = response?.data.message || data.message || 'Application error';
      self.alertStore.showAlert(msg);
      this.setGlobalLoading(false);
      throw new Error(msg);
    },
    setGlobalLoading(state: boolean) {
      self.globalLoading = state;
    },
    toggleTheme() {
      const newTheme = self.theme === 'dark' ? 'light' : 'dark';
      localStorage.setItem('theme', newTheme);
      self.theme = newTheme;
      document.documentElement.classList.toggle('dark', newTheme === 'dark');
    },
    setTheme(theme: Theme) {
      localStorage.setItem('theme', theme);
      self.theme = theme;
      document.documentElement.classList.toggle('dark', theme === 'dark');
    },
    setInitSelectedCountryCode(data: ISelectedCountryCodeData) {
      const savedCC = localStorage.getItem('savedCC');
      if (savedCC) {
        const { id, countryCodeData } = JSON.parse(savedCC);
        if (data.id === id) {
          self.selectedCountryCode = countryCodeData;
          return;
        }
      }
      localStorage.setItem('savedCC', JSON.stringify(data));
      self.selectedCountryCode = data.countryCodeData;
    },
    setSelectedCountryCode(data: ISelectedCountryCodeData | null) {
      if (data) {
        localStorage.setItem('savedCC', JSON.stringify(data));
        self.selectedCountryCode = data.countryCodeData;
        self.alertStore.showAlert('Country code has been changed', 'success');
      } else {
        localStorage.removeItem('savedCC');
        self.selectedCountryCode = null;
      }
    },
  }));
